import { initContract } from '@ts-rest/core'
import {
  SubscribePushRequestSchema,
  SubscribePushResponseSchema,
  UnsubscribePushRequestSchema,
  UnsubscribePushResponseSchema,
} from '../schemas/push'
import { defaultErrorResponses } from './errors'

const c = initContract()

/**
 * Web-push subscription contract (Issue #484).
 *
 * Lets an authenticated browser register / remove a Push API subscription so
 * the backend can fan out "scan ready" notifications across the user's
 * devices. All endpoints require auth and are RLS-scoped to the caller.
 *
 * Distinct from `subscriptionContract` (Stripe billing).
 */
export const pushContract = c.router({
  subscribe: {
    method: 'POST',
    path: '/v1/push/subscribe',
    body: SubscribePushRequestSchema,
    responses: {
      200: SubscribePushResponseSchema,
      ...defaultErrorResponses,
    },
    metadata: {
      auth: true,
      summary: 'Register a web-push subscription',
      description:
        'Idempotently upserts the calling user\'s browser PushSubscription (keyed by endpoint). Used to deliver scan-complete notifications.',
    },
  },
  unsubscribe: {
    method: 'POST',
    path: '/v1/push/unsubscribe',
    body: UnsubscribePushRequestSchema,
    responses: {
      200: UnsubscribePushResponseSchema,
      ...defaultErrorResponses,
    },
    metadata: {
      auth: true,
      summary: 'Remove a web-push subscription',
      description:
        'Deletes the calling user\'s subscription identified by endpoint. Returns removed_count=0 when the endpoint was already gone.',
    },
  },
})
